import React, { useState, useEffect, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import { NotificationManager } from "react-notifications";
import MainService from "../../Common/MainService";
import "./SiteUpdatesComponent.css";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import CustomPopup from "../../Common/CustomPopup/CustomPopupComponent";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import SearchBar from "material-ui-search-bar";
import ListIcon from "@material-ui/icons/List";
import GridIcon from "@material-ui/icons/GridOnOutlined";
import MapIcon from "@material-ui/icons/MapRounded";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Box, Button } from "@mui/material";
import DeleteContent from "../../Common/CommonContent/DeleteContent";
import DeleteContentSubCategory from "../../Common/CommonContent/DeleteContentSubCategory";
import CreateContentSubCategory from "../../Common/CommonContent/CreateContentSubCategory";
import { getCategoryID } from "../../Common/CommonContent/ContentedRelatedCommonFun";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  uploadButton: {
    margin: theme.spacing(1),
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(5),
    right: theme.spacing(5),
    zIndex: 10,
    color: "#fff",
  },
  menuPaper: {
    width: 200,
    minHeight: 50,
    maxHeight: 150,
    marginTop: 45,
  },
  menuPaperForm: {
    minHeight: 50,
    maxHeight: 150,
    marginTop: 45,
  },
}));

export default function SiteUpdatesComponent(props) {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [siteupdatesPopup, setShowSiteUpdatesPopup] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedCategoryName, setSelectedCategoryName] =
    useState("site-updates");
  const [subCategoryNameValue, setSubCategoryNameValue] = useState("");
  const [siteUpdatesList, setSiteUpdatesList] = useState([]);
  const [filteredSiteUpdatesList, setFilteredSiteUpdatesList] = useState([]);
  const [subCategoriesList, setsubCategoriesList] = useState([]);
  const { user } = MainService.getLocalData();
  const { username, parentId } = user;
  const [subcategorydialog, setSubCategoryDialog] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [siteupdatesNameValue, setSiteUpdatesNameValue] = useState("");
  const [descriptionValue, setDescriptionValue] = useState("");
  const [priceValue, setPriceValue] = useState("");
  const [expiryDateValue, setExpiryDateValue] = useState("");
  const [discountValue, setDiscountValue] = useState("");
  const [siteupdatesFile, setSiteUpdatesFile] = useState(null);
  const [siteupdatesFileDescription, setSiteUpdatesFileDescription] =
    useState(null);
  const [deleteSubcategoryDialog, setDeleteSubCategoryDialog] = useState(false);
  const [deleteContentDialog, setDeleteContentDialog] = useState(false);
  const [listView, setListView] = useState(false);
  const [gridView, setGridView] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [getFarmSites, setFarmSites] = useState([]);
  const [framSiteValue, setFarmSiteValue] = useState("");
  /* delete content */
  const [selectedContentId, setSelectedContentId] = useState("");
  const [getDeleteContentCreator, setDeleteContentCreator] = useState("");
  const [getDeleteContentCategory, setDeleteContentCategory] = useState("");

  useEffect(() => {
    if (!selectedCategoryId) return;
    getSubCategories();
  }, [selectedCategoryId]);

  useMemo(async () => {
    await getCategoryID(selectedCategoryName)
      .then((data) => {
        if (data.length > 0) {
          setSelectedCategoryId(data);
        } else {
          setSelectedCategoryId("");
        }
      })
      .catch((e) => {
        return NotificationManager.error("error");
      });
  }, []);

  const getSubCategories = () => {
    MainService.getSubCategoriesForAD(username, selectedCategoryId)
      .then((data) => {
        if (data.length > 0) {
          setSelectedSubCategory(data[0].contentsubcategoryname);
          setsubCategoriesList(data);
          setIsLoading(false);
        } else {
          setsubCategoriesList(data);
          setSelectedSubCategory("");
          setIsLoading(false);
        }
      })
      .catch((e) => {
        return NotificationManager.error(e);
      });
  };
  const getAllContentsList = () => {
    setSubCategoryNameValue("");
    setIsLoading(true);
    MainService.getCategoryTender(parentId, selectedCategoryId)
      /* MainService.getAllContentsList(
        username,
        selectedCategoryId,
        selectedSubCategory
      ) */
      .then((data) => {
        if (data.length > 0) {
          setIsLoading(false);
          setSiteUpdatesList(data);
          setFilteredSiteUpdatesList(data);
        } else {
          setSiteUpdatesList(data);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        return NotificationManager.error(e);
      });
  };

  useMemo(() => {
    if (!parentId) return;
    if (!selectedCategoryId) return;
    getAllContentsList();
  }, [selectedCategoryId]);

  const createSubCategoryClick = () => {
    setSubCategoryDialog(!subcategorydialog);
  };

  /*Delete Sub-Category */
  const deleteSubCategoryClick = () => {
    setDeleteSubCategoryDialog(!deleteSubcategoryDialog);
  };
/* EOD Delete Sub-Category */

  const createSiteUpdatesClick = () => {
    setShowSiteUpdatesPopup(!siteupdatesPopup);
  };
  const submitSiteUpdatesClick = () => {
    const siteupdatesData = new FormData();
    siteupdatesData.append("file", siteupdatesFile);
    siteupdatesData.append("mimetype", siteupdatesFile.type);
    siteupdatesData.append("categoryid", selectedCategoryId);
    siteupdatesData.append("categoryname", selectedCategoryName);
    siteupdatesData.append("contentsubcategory", subCategoryNameValue);
    siteupdatesData.append("contentname", siteupdatesNameValue);
    siteupdatesData.append("assetdeveloperid", parentId);
    siteupdatesData.append("contentdescription", descriptionValue);
    siteupdatesData.append("contentcreator", username);
    siteupdatesData.append("contentformat", "DOC");
    siteupdatesData.append("price", "none");
    siteupdatesData.append("filedescription", siteupdatesFileDescription);
    siteupdatesData.append("contentownerid", framSiteValue);
    siteupdatesData.append("unit", "INR");
    siteupdatesData.append("discountedprice", "none");
    siteupdatesData.append("expirydate", "none");
    siteupdatesData.append("event", "none");

    MainService.createContent(siteupdatesData, parentId)
      .then((res) => {
        getAllContentsList();
        return NotificationManager.success("SiteUpdates uploaded");
      })
      .catch((e) => {
        return NotificationManager.error(e);
      });
    setShowSiteUpdatesPopup(!siteupdatesPopup);
  };
/* Delete Content */
  const deleteContentDialogClick = (siteupdates) => {
    if (siteupdates.contentcreatorid === username) {
      setSelectedContentId(siteupdates.contentid);
      setDeleteContentCreator(siteupdates.contentcreatorid);
      setDeleteContentCategory(siteupdates.categoryid);
      setDeleteContentDialog(!deleteContentDialog);
    } else {
      return NotificationManager.error(
        "You can't delete other creator content"
      );
    }
  };

  const closeDeleteContent = () => {
    setDeleteContentDialog(!deleteContentDialog);
  };
/* EOD Delete Content */

  const viewAllBuySiteUpdatesClick = () => {
    getAllContentsList();
    setSelectedSubCategory("FARM");
  };

  const listViewClick = () => {
    setListView(true);
    setGridView(false);
  };
  const gridViewClick = () => {
    setListView(false);
    setGridView(true);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  /* get Sites Related to Farm */
  useEffect(() => {
    if (!parentId) return;
    if (!username) return;
    getAllSites();
  }, [parentId, username]);

  const getAllSites = () => {
    MainService.viewAllSites(parentId, username)
      .then((data) => {
        if (data["sites"].length > 0) {
          const distorgdata = data.sites.filter((distorg) => {
            return distorg.sitetype === "Farm";
          });
          setFarmSites(distorgdata);
        }
      })
      .catch((e) => {
        return NotificationManager.error(e);
      });
  };
  /* END get Sites Related to Physical-Market */

  /*Create SiteUpdates */
  const closeSiteUpdatesModal = (
    <span
      onClick={() => {
        setShowSiteUpdatesPopup(!siteupdatesPopup);
      }}
    >
      X
    </span>
  );
  const titleSiteUpdates = "Create SiteUpdates";
  const siteupdatesBody = (
    <div style={{ margin: "10px" }}>
      <FormControl fullWidth={true} className="loginFields">
        <InputLabel htmlFor="categoryName">Category Name :</InputLabel>
        <Input
          disabled
          id="categoryName"
          name="categoryName"
          type="text"
          value={selectedCategoryName.toUpperCase()}
        />
      </FormControl>
      <FormControl fullWidth={true} className="loginFields">
        <InputLabel htmlFor="subCategoryName">Sub-Category Name :</InputLabel>
        <Select
          id="subCategoryName"
          name="subCategoryName"
          type="text"
          value={subCategoryNameValue}
          onChange={(e) => {
            setSubCategoryNameValue(e.target.value);
          }}
          MenuProps={{ classes: { paper: classes.menuPaperForm } }}
        >
          {subCategoriesList &&
            subCategoriesList.map((idObj, index) => (
              <MenuItem key={`${index} `} value={idObj.contentsubcategoryname}>
                {idObj.contentsubcategoryname}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <FormControl fullWidth={true} className="loginFields">
        <InputLabel htmlFor="siteupdatesName">SiteUpdates Name :</InputLabel>
        <Input
          id="siteupdatesName"
          name="siteupdatesName"
          type="text"
          value={siteupdatesNameValue}
          onChange={(e) => {
            setSiteUpdatesNameValue(e.target.value);
          }}
        />
      </FormControl>
      <FormControl fullWidth={true} className="loginFields">
        <InputLabel htmlFor="contentowner">Content Owner :</InputLabel>
        <Select
          id="contentowner"
          name="contentowner"
          type="text"
          value={framSiteValue}
          onChange={(e) => {
            setFarmSiteValue(e.target.value);
          }}
          MenuProps={{ classes: { paper: classes.menuPaperForm } }}
        >
          {getFarmSites &&
            getFarmSites.map((idObj, index) => (
              <MenuItem key={`${index} `} value={idObj.sitename}>
                {idObj.sitename}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <FormControl fullWidth={true} className="loginFields">
        <InputLabel htmlFor="contentCreator"> Content Creator:</InputLabel>
        <Input
          disabled
          id="contentCreator"
          name="contentCreator"
          type="text"
          value={username}
        />
      </FormControl>
      <FormControl fullWidth={true} className="loginFields">
        <InputLabel htmlFor="zone"> Content Approver:</InputLabel>
        <Input
          disabled
          id="contentApprover"
          name="contentApprover"
          type="text"
          value={parentId}
        />
      </FormControl>
      <FormControl fullWidth={true} className="loginFields">
        <InputLabel htmlFor="description"> Description:</InputLabel>
        <Input
          id="description"
          name="description"
          type="text"
          value={descriptionValue}
          onChange={(e) => {
            setDescriptionValue(e.target.value);
          }}
        />
      </FormControl>
      <FormControl fullWidth={true} className="loginFields">
        <InputLabel htmlFor="doc">file:</InputLabel>
        <Input
          id="doc"
          name="doc"
          type="file"
          onChange={(e) => {
            setSiteUpdatesFile(e.target.files[0]);
          }}
        />
      </FormControl>
      <Box>
        <Button
          sx={{ m: "5px" }}
          variant="contained"
          color="primary"
          className="registerBtn"
          type="submit"
          onClick={() => {
            submitSiteUpdatesClick();
          }}
        >
          Submit
        </Button>
        <Button
          sx={{ m: "5px" }}
          variant="contained"
          color="error"
          onClick={() => {
            setShowSiteUpdatesPopup(!siteupdatesPopup);
          }}
        >
          Close
        </Button>
      </Box>
    </div>
  );

  return (
    <>
      <div className="container" id="mainContentList">
        <Fab
          color="primary"
          size={"large"}
          aria-label="add"
          title="Upload SiteUpdates"
          className={classes.fab}
          onClick={() => {
            createSiteUpdatesClick();
          }}
        >
          <AddIcon></AddIcon>
        </Fab>
        <Box
          sx={{
            display: "flex",
            gap: "0.5rem",
            flexWrap: "wrap",
            flexDirection: { xs: "column", sm: "column", md: "row" },
          }}
        >
          <Button
            sx={{
              background: "#3ECF8E",
              margin: "2px",
              width: { xs: "100%", sm: "70%", md: "auto" },
            }}
            color="primary"
            className="registerBtn"
            variant="contained"
            onClick={() => {
              viewAllBuySiteUpdatesClick();
            }}
          >
            View All Site-Updates
          </Button>

          <Button
            sx={{
              background: "#3ECF8E",
              margin: "2px",
              width: { xs: "100%", sm: "70%", md: "auto" },
            }}
            color="primary"
            className="registerBtn"
            variant="contained"
            onClick={() => {
              createSubCategoryClick();
            }}
          >
            Create Sub-Category
          </Button>
          <Button
            sx={{
              background: "#3ECF8E",
              margin: "2px",
              width: { xs: "100%", sm: "70%", md: "auto" },
            }}
            color="primary"
            className="registerBtn"
            variant="contained"
            onClick={() => {
              deleteSubCategoryClick();
            }}
          >
            Delete Sub-Category
          </Button>
          <FormControl variant="outlined" size="small" className="postdropdown">
            <InputLabel
              style={{
                color: "rgb(43, 144, 99)",
                fontSize: "15px",
              }}
            >
              Filter by Sub-Category
            </InputLabel>
            <Select
              id="selectedSubCategory"
              value={subCategoryNameValue}
              onChange={(e) => {
                setSubCategoryNameValue(e.target.value);
                const filteredRows = filteredSiteUpdatesList.filter((row) => {
                  return row.contentsubcategory
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase());
                });
                setSiteUpdatesList(filteredRows);
              }}
              label="Select Sub-Category"
              MenuProps={{ classes: { paper: classes.menuPaper } }}
            >
              {subCategoriesList &&
                subCategoriesList.map((idObj, index) => (
                  <MenuItem
                    key={`${index} `}
                    value={idObj.contentsubcategoryname}
                  >
                    {idObj.contentsubcategoryname}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Box>
        <div className="MuiGrid-root">
          <div style={{ float: "right" }}>
            <Button
              startIcon={<ListIcon />}
              size="large"
              onClick={listViewClick}
            ></Button>
            <Button
              startIcon={<GridIcon />}
              size="large"
              onClick={gridViewClick}
            ></Button>
          </div>
          <h2>Site Update Details</h2>
          {listView && (
            <Paper sx={{ width: "100%" }}>
              <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow align="center">
                      <TableCell align="center" colSpan={1}>
                        Assetdeveloperid
                      </TableCell>
                      <TableCell align="center" colSpan={1}>
                        Content Id
                      </TableCell>
                      <TableCell align="center" colSpan={1}>
                        Category
                      </TableCell>
                      <TableCell align="center" colSpan={1}>
                        Category Id
                      </TableCell>
                      <TableCell align="center" colSpan={1}>
                        Content Uploader
                      </TableCell>
                      <TableCell align="center" colSpan={1}>
                        Organization
                      </TableCell>
                      <TableCell align="center" colSpan={1}>
                        Sub Category Name
                      </TableCell>
                      <TableCell align="center" colSpan={1}>
                        Description
                      </TableCell>
                      <TableCell align="center" colSpan={1}>
                        Price
                      </TableCell>
                      <TableCell align="center" colSpan={1}>
                        expiry Date
                      </TableCell>
                      <TableCell align="center" colSpan={1}>
                        Download Document
                      </TableCell>
                      <TableCell align="center" colSpan={2}>
                        Option
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {siteUpdatesList.length > 0 ? (
                      siteUpdatesList
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((siteupdates, index) => {
                          return (
                            <TableRow hover tabIndex={-1} key={index}>
                              <TableCell align="center">
                                {siteupdates.parentid}
                              </TableCell>
                              <TableCell align="center">
                                {siteupdates.contentid}
                              </TableCell>
                              <TableCell align="center">
                                {siteupdates.categoryname}
                              </TableCell>
                              <TableCell align="center">
                                {siteupdates.categoryid}
                              </TableCell>
                              <TableCell align="center">
                                {siteupdates.contentcreatorid}
                              </TableCell>
                              <TableCell align="center">
                                {siteupdates.contentowner}
                              </TableCell>
                              <TableCell align="center">
                                {siteupdates.contentsubcategory}
                              </TableCell>
                              <TableCell align="center">
                                {siteupdates.contentdescription}
                              </TableCell>
                              <TableCell align="center">
                                {siteupdates.price}
                              </TableCell>
                              <TableCell align="center">
                                {siteupdates.contentexpirydate}
                              </TableCell>
                              <TableCell align="center">
                                <a
                                  className="downloadDocument"
                                  href={siteupdates.locationurl}
                                  download
                                >
                                  Download Document
                                </a>
                              </TableCell>
                              <TableCell align="center">
                                <Button
                                  type="button"
                                  variant="contained"
                                  onClick={() => {
                                    deleteContentDialogClick(siteupdates);
                                  }}
                                >
                                  Delete
                                </Button>
                              </TableCell>
                            </TableRow>
                          );
                        })
                    ) : (
                      <TableRow align="center">
                        <TableCell align="center" colSpan={12}>
                          Siteupdates Not Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={siteUpdatesList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          )}
          {gridView && (
            <div className="cardStyleForDashboardItems">
              {isLoading ? (
                <div className="cardStyleForDashboardItems">
                  <CircularProgress />
                </div>
              ) : (
                <div className="cardStyleForDashboardItems">
                  {siteUpdatesList.length > 0 ? (
                    <div className="cardStyleForDashboardItems">
                      {siteUpdatesList.map((siteupdates, index) => (
                        <div
                          key={index}
                          className="cardStyleForDashboardItemsBody"
                        >
                          <span>
                            <p>
                              <b>Assetdeveloperid:</b>
                              {siteupdates.parentid}
                            </p>
                            <p>
                              <b>Content Id:</b>
                              {siteupdates.contentid}
                            </p>
                          </span>
                          <p>
                            <b>Category Id:</b>
                            {siteupdates.categoryid}
                          </p>
                          <p>
                            <b>Content Creator:</b>
                            {siteupdates.contentcreatorid}
                          </p>
                          <p>
                            <b>Category:</b>
                            {siteupdates.categoryname}
                          </p>
                          <p>
                            <b>Organization:</b>
                            {siteupdates.contentowner}
                          </p>
                          <p>
                            <b>Sub Categoryname:</b>
                            {siteupdates.contentsubcategory}
                          </p>
                          <p>
                            <b>Description:</b>
                            {siteupdates.contentdescription}
                          </p>
                          <p>
                            <b>Price:</b>
                            {siteupdates.price}
                          </p>
                          <p>
                            <b>Expiry Date:</b>
                            {siteupdates.contentexpirydate}
                          </p>
                          <a
                            className="downloadDocument"
                            href={siteupdates.locationurl}
                            download
                          >
                            Download Document
                          </a>
                          <div>
                            <Button
                              type="button"
                              variant="contained"
                              onClick={() => {
                                deleteContentDialogClick(siteupdates);
                              }}
                            >
                              Delete
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <h4>Sites not found.</h4>
                  )}
                </div>
              )}
            </div>
          )}
        </div>

        <CreateContentSubCategory
          reLoad={getSubCategories}
          userName={username}
          categoryId={selectedCategoryId}
          categoryName={selectedCategoryName}
          parentID={parentId}
          onOpen={subcategorydialog}
          onClose={createSubCategoryClick}
        />

        <DeleteContentSubCategory
          reLoad={getSubCategories}
          userName={username}
          categoryId={selectedCategoryId}
          subCategoryList={subCategoriesList}
          onOpen={deleteSubcategoryDialog}
          onClose={deleteSubCategoryClick}
        />

        <DeleteContent
          reLoad={getAllContentsList}
          contentId={selectedContentId}
          contentCreator={getDeleteContentCreator}
          contentCategory={getDeleteContentCategory}
          onOpen={deleteContentDialog}
          onClose={closeDeleteContent}
        />

        <CustomPopup
          closeButton={closeSiteUpdatesModal}
          isOpen={siteupdatesPopup}
          closeModal={siteupdatesPopup}
          content={siteupdatesBody}
          title={titleSiteUpdates}
        />
      </div>
    </>
  );
}
